import { toast } from "react-toastify";
import { toastKeys } from "./constants";

function documentsDateConversion(date: any) {
  const dateArray = date?.split("T");
  const modifiedDateCreatedAt = dateArray?.[0]
    ?.split("-")
    ?.reverse()
    ?.join("-");

  return modifiedDateCreatedAt || "";
}


function toastHandler(message: string, type: string) {
  if (message) {
    toast(message, { ...toastKeys, type: type });
  }
}

export {documentsDateConversion, toastHandler}